export const Color = {
  light: {
    primary: '#FED766',

    bg: '#fafafa',
    'bg-hover': '#eeeeee',

    layer: '#f1f1f1',
    'layer-hover': '#e0e0e0',

    'layer-accent': '',
    'layer-accent-hover': '',

    field: '',
    'field-active': '',

    border: '',
    'border-focused': '',
    'border-strong': '',
    'border-disabled': '',

    'border-layer': '',
    'border-layer-focused': '',
    'border-layer-strong': '',
    'border-layer-disabled': '',

    'text-primary': '#424242',
    'text-secondary': '',
    'text-placeholder': '',
    'text-on-primary': '',
    'text-on-primary-disabled': '',
    'text-error': '#f44336',
    'text-disabled': '',

    'link-primary': '#2196f3',
    'link-primary-hover': '',

    'skeleton-element': '',
    'skeleton-bg': '',
  },
  dark: {
    primary: '#FED766',

    bg: '#424242',
    'bg-hover': '#757575',

    layer: '#616161',
    'layer-hover': '#9e9e9e',

    'layer-accent': '',
    'layer-accent-hover': '',

    field: '',
    'field-active': '',

    border: '',
    'border-focused': '',
    'border-strong': '',
    'border-disabled': '',

    'border-layer': '',
    'border-layer-focused': '',
    'border-layer-strong': '',
    'border-layer-disabled': '',

    'text-primary': '#fafafa',
    'text-secondary': '',
    'text-placeholder': '',
    'text-on-primary': '',
    'text-on-primary-disabled': '',
    'text-error': '#ef5350',
    'text-disabled': '',

    'link-primary': '#42a5f5',
    'link-primary-hover': '',

    'skeleton-element': '',
    'skeleton-bg': '',
  },
};
